import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { getTagSlug } from 'features/tags/utils/tag'
import type { TagItem } from 'features/tags/types/tags.types'

type UseCreateTagMutationProps = {
	onSuccess: () => void
}

export const useCreateTagMutation = ({ onSuccess }: UseCreateTagMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: createTag, isPending: createTagLoading } = useMutation({
		mutationFn: ({ name }: Pick<TagItem, 'name'>) => {
			return axiosPrivate.post(apiRoutes.tags(), { name, slug: getTagSlug(name) })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.tags.all })
			useToast({ type: 'success', message: t('Tag created') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createTag,
		createTagLoading
	}
}
